import styled from 'styled-components';
import { Colors } from '../../utils/style/colors';

export const AppBackground = styled.div`
	position: absolute;
	width: 100%;
    height: 100%;
	z-index: -1;
	background-size: cover;
	background: ${Colors.gray50};
    flex-direction: column;
    left: 450px;
    right: 0;
    top: 0;
    > div {
        position: relative;
        width: 100%;
        height: 100%;
    }
`;
export const Img = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;    
    transition: opacity 1000ms;
    opacity: ${props => props.visible ? 1 : 0};
    background-image: url(${props => props.src});
    background-size: cover;
    background-position: center;
    &:before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background: rgba(0,0,0,.7);
    }
`;